import axiosInstance from "../api/axios";

// BuildVizer internal team management — one stop for internal Admins + BV Users. ZUMALE-admin only.
// Deactivation is a reversible toggle (updateâ€¦ { active }); delete is permanent (DELETE).

// --- Internal Admins (full internal access; root protected) ---
export const getTeamMembers = () => axiosInstance.get(`/team/members`);
// payload: { name, email, mobileNoWa? } — password generated + emailed by the backend.
export const createTeamMember = (payload) => axiosInstance.post(`/team/members`, payload);
// payload: { name?, email?, mobileNoWa?, active? }
export const updateTeamMember = (loginId, payload) => axiosInstance.put(`/team/members/${loginId}`, payload);
export const deleteTeamMember = (loginId) => axiosInstance.delete(`/team/members/${loginId}`);

// --- BV Users (field associates; assigned to developer projects internally) ---
export const getBvUsers = () => axiosInstance.get(`/team/bv-users`);
export const createBvUser = (payload) => axiosInstance.post(`/team/bv-users`, payload);
export const updateBvUser = (loginId, payload) => axiosInstance.put(`/team/bv-users/${loginId}`, payload);
export const deleteBvUser = (loginId) => axiosInstance.delete(`/team/bv-users/${loginId}`);
